import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './assets/main.css'
import '@babel/polyfill'
import Vue from 'vue'
import Vant from 'vant';
import VueRouter from 'vue-router'
import { Tab, Tabs, Swipe, SwipeItem, Popup, NoticeBar, List } from 'vant'
import 'vant/lib/index.css'
import App from './App.vue'
import router from './router'
import store from "./stores/counter.js";
import VueLazyload from 'vue-lazyload';
import 'video.js/dist/video-js.css';
import VideoPlayer from 'vue-video-player';

Vue.config.productionTip = false
Vue.use(VideoPlayer);
Vue.use(Vant);
Vue.use(VueRouter) 
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Popup)
Vue.use(NoticeBar)
Vue.use(List)
Vue.use(VueLazyload, {
  loading: '@/assets/loading.gif', 
  error: '@/assets/error.png' 
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')